import styled from 'styled-components';
import { ReactNode } from 'react';

export const ContainerButtons = styled.div<{
  children?: ReactNode;
}>`
  width: 90%;
  margin: 0 auto;
  max-width: 801px;
  padding-top: 42px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  button {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 20px;
    text-transform: uppercase;
    svg {
      margin-right: 10px;
    }
  }
  @media screen and (min-width: 768px) {
    flex-direction: row;
    button {
      margin-bottom: 0;
    }
  }
`;
